import { InputField } from "@risalabs_frontend_org/oasis-ui-kit";

interface SourceConfirmationFieldsProps {
  sourceText: string;
  suggestions: string[];
  onChange: (value: string) => void;
}

/** Confirmed source field with click-to-fill suggestions. */
const SourceConfirmationFields = ({
  sourceText,
  suggestions,
  onChange,
}: SourceConfirmationFieldsProps) => (
  <div>
    <InputField
      id="confirmed-source"
      label="Confirmed source"
      size="md"
      fullWidth
      required
      value={sourceText}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Type the confirmed source, or pick a suggestion below"
    />
    {suggestions.length > 0 && (
      <>
        <div className="mb-2 mt-3 text-tiny font-normal tracking-wider text-[#6b7380]">
          Suggested sources — click to fill:
        </div>
        <div className="flex flex-wrap gap-2">
          {suggestions.map((suggestion) => (
            <button
              key={suggestion}
              type="button"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => onChange(suggestion)}
              className={`rounded-full px-3 py-1.5 text-sm transition-colors ${
                sourceText === suggestion
                  ? "border-[1.5px] border-[#2673F2] font-bold text-[#2673F2]"
                  : "border border-primaryGray-14 font-medium text-primaryGray-1 hover:bg-primaryGray-16"
              }`}
            >
              {suggestion}
            </button>
          ))}
        </div>
      </>
    )}
  </div>
);

export default SourceConfirmationFields;
